type ModifiedState<T> = Record<number, T>

export function changeModified<T = any>(
  setState: React.Dispatch<React.SetStateAction<ModifiedState<T>>>,
  id: number,
  newValue: T,
  defaultValue?: T,
) {
  setState((prev) => {
    // if value is same -> remove key (no longer dirty)
    if (defaultValue === newValue) {
      const { [id]: _, ...rest } = prev
      return rest
    }

    return {
      ...prev,
      [id]: newValue
    }
  })
}
